// extracted by mini-css-extract-plugin
export var body = "FooterCampaign-module--body--d706c";
export var cta = "FooterCampaign-module--cta--366ee";
export var halfPipe = "FooterCampaign-module--halfPipe--2c2b9";
export var heading = "FooterCampaign-module--heading--e0b3e";
export var innerWrapper = "FooterCampaign-module--innerWrapper--c3eea";
export var wrapper = "FooterCampaign-module--wrapper--94f18";